module.exports = __webpack_public_path__ + "static/media/kompas_med_rettede_bogstaver.da93483a.png";